import {BUSCAR_RESUMO_FINANCEIRO, BUSCAR_RESUMO_FINANCEIRO_ITINERARIO, FILTRAR_RESUMO_FINANCEIRO, LIMPAR_RESUMO_FINANCEIRO} from '../../actions/types'

const itemInicial = {
    resumos: [],
    resumosInicial: []
};

export default function reducerResumoFinanceiro(state = itemInicial, action) {
    switch (action.type) {
        case BUSCAR_RESUMO_FINANCEIRO: {
            return {
                ...state,
                resumos: action.payload,
                resumosInicial: action.payload
            };
        }

        case BUSCAR_RESUMO_FINANCEIRO_ITINERARIO: {
            return {
                ...state,
                resumos: action.payload,
                resumosInicial: action.payload
            };
        }

        case LIMPAR_RESUMO_FINANCEIRO: {
            return {
                ...state,
                resumos: [],
                resumosInicial: []
            };
        }

        case FILTRAR_RESUMO_FINANCEIRO: {
            return {
                ...state,
                resumos: action.payload.resumo.filter(
                    l => (l.nome && l.nome.toLowerCase().includes(action.payload.texto.toLowerCase()) || (l.nomeEmpresa && l.nomeEmpresa.toLowerCase().includes(action.payload.texto.toLowerCase())))
                )
            };
        }

        default: {
            return state
        }
    }
}
